import styled, { css } from "styled-components";
import { PanelNav as PanelNavLayout } from "@sonder/ui/source/styled/layouts/PanelNav";
import { colors } from "@sonder/ui/source/styled/theme";

const fixedWidthStyles = css`
  flex-grow: 0;
  flex-shrink: 0;
`;
interface PanelNavProps {
  primaryColor?: string;
  secondaryColor?: string;
  childRight?: boolean;
  childLeft?: boolean;
}
export const PanelNav = styled(PanelNavLayout)<PanelNavProps>`
  background: ${props => props.secondaryColor || colors.grayE};
  color: ${props => props.primaryColor || colors.gray1};
  flex-shrink: 0;
  font-size: 0.75rem;
  width: 100%;
  padding: 0 1rem;
  > * {
    flex-grow: 1;
  }
  > :first-child {
    ${props => props.childLeft && fixedWidthStyles}
  }
  > :last-child {
    ${props => props.childRight && fixedWidthStyles}
  }
`;
